// frontend/shared/src/api/pending.ts —— TD-813 接口未就绪适配器
import type { PendingRouteKey } from './routes.pending';

export class NotReadyError extends Error {
  readonly endpoint: PendingRouteKey;
  constructor(endpoint: PendingRouteKey) {
    super(`接口未就绪：${endpoint}`);
    this.name = 'NotReadyError';
    this.endpoint = endpoint;
  }
}

const warned = new Set<string>();

export function notReady<T>(endpoint: PendingRouteKey): Promise<T> {
  if (!warned.has(endpoint)) {
    warned.add(endpoint);
    console.warn('[gp:not-ready]', endpoint);
  }
  return Promise.reject(new NotReadyError(endpoint));
}

export function isNotReady(e: unknown): e is NotReadyError {
  return e instanceof NotReadyError;
}

export function resetNotReadyWarnings(): void {
  warned.clear();
}
